export default "__VITE_ASSET__CNR77jRV__"